jQuery("#webform-submission-otp-login-node-121-add-form #edit-phone-number").keyup(function(){
  var cellphone = jQuery(this).val();
  if (cellphone.charAt(0) === '0') {
      jQuery(this).val('27');
  }
  if(cellphone.charAt(2) === '0') {
      jQuery(this).val('27');
  }
  jQuery(this).val(jQuery(this).val().replace(/\s/g, ''));
});



// WEBPACK FOOTER //
// ./js/components/otp/_otp--login.js